<obg-m-dialog-layout #dialog [hideFooter]="true" [titleText]="titleText">
	<iframe class="dialog-iframe" obgIframe [src]="src"></iframe>
</obg-m-dialog-layout>
